export const appName: string = "MJMD Global";
export const appTitle: string = `MJMD Global | Product Development, Fashion, Surgical Services, Mediation, Horse Racing, Go Touchless`;
export const metaDescription: string = `We are a management and product development company whose primary mission is to “Create New History!” Through product innovation, fashion, surgical services, mediation and even horse racing, a new energy, and new history is created. Our ultimate theme is to “Go Touchless!”`;
export const metaKeywords: string =
  "MJMD Global: Management, Product Development, Create New History, Product Innovation, Fashion, Surgical Services, Mediation, Horse Racing, Go Touchless";

export const siteAuthor = `Gerardo I. Ornelas <gerardo@ornelastechnologies.com>`;
export const siteUrl = `https://www.mjmdglobal.com`;
export const twitterHandle = `@mjmdglobal`;
